import { HTTPClient } from '../utils/request'

export default {
  index: () => HTTPClient.get(`/category_settings`),
  show: ({ params = '' }) =>
    HTTPClient.get(`/settings-by-category/${params._id}`),
  update: ({ params = '', payload }) =>
    HTTPClient.put(`/settings-by-category/${params._id}`, payload)
}
